import { render, staticRenderFns } from "./BadgeText.vue?vue&type=template&id=3a8ba3ba&scoped=true&"
import script from "./BadgeText.vue?vue&type=script&lang=js&"
export * from "./BadgeText.vue?vue&type=script&lang=js&"
import style0 from "./BadgeText.vue?vue&type=style&index=0&id=3a8ba3ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ba3ba",
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip});
